

import LayoutMain from '@/layout';
import setting from '@/setting';
let routePre = setting.routePre;

const meta = {
  auth: true,
};

const pre = 'job_';

export default {
  path: routePre + '/job',
  name: 'job',
  header: 'job',
  redirect: {
    name: `${pre}index`,
  },
  component: LayoutMain,
  children: [
	
	{
	  path: 'index',
	  name: `${pre}index`,
	  meta: {
	    auth: ['job'],
	    title: '病例',
		hiddenMenu:true
	  },
	  component: () => import('@/pages/job/index'),
	},
	
	
	{
	  path: 'log',
	  name: `${pre}log`,
	  meta: {
	    auth: ['job'],
	    title: '病例记录',
		hiddenMenu:true,
		activeMenu: routePre + '/job/index',
	  },
	  component: () => import('@/pages/job/log'),
	},
  ],
};
